export default {
    baseStyle: {
        productViewHeaderContainer: {
            mr: 4,
            spacing: 2,
            align: 'flex-start',
            marginBottom: [4, 4, 4, 0, 0]
        },
        productViewHeaderTitle: {
            width: {base: 'auto', md: 'auto ', lg: '242.17px'},
            fontSize: '2xl',
            marginBottom: '10px',
            textTransform: 'uppercase'
        },
        productViewHeaderPrice: {
            fontFamily: 'Inter',
            fontSize: '12px'
        },
        productPrice: {
            display: {base: 'flex', md: 'flex', lg: ''},
            gap: {base: '6px', md: '6px', lg: ''}
        },
        productViewPageButtonAddToCart: {
            width: 'full'
        },
        productDescription: {
            padding: {base: '10px', md: '10px', lg: 'initial'},
            width: {base: 'auto', md: 'auto ', lg: '342px'},
            maxWidth: {base: 'none', md: '538px ', lg: '618px'},
            height: {base: 'none', md: 'none', lg: '726px'},
            position: {base: 'none', md: 'none', lg: 'sticky'},
            marginLeft: {base: 'none', md: 'none', lg: 'auto'},
            marginRight: {base: 'none', md: 'none', lg: 'auto'},
            marginTop: {base: 'none', md: 'none', lg: '120px'},
            top: {base: 'none', md: 'none ', lg: '80px'}
        },
        productImages: {
            flex: 1,
            mr: [0, 0, 0, 6, 6],
            position: {base: '', md: '', lg: 'sticky'},
            minWidth: {base: 'none', lg: '50%'},
            maxWidth: {base: 'none', lg: '816px', xl: '816px'},
            margin: {base: '-16px -16px 0 -16px', md: '0 0 32px 0', lg: '0'}
        },
        productAttributes: {
            align: 'stretch',
            gap: [0, null, null, 24],
            flex: [1, null, null, '1 0 50%'],
            pl: [0, null, null, 16]
        },
        productSwatches: {
            mb: 16,
            position: 'relative'
        },
        productBrandHeader: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            fontSize: {
                base: '20px',
                md: '32px'
            },
            fontStyle: 'normal',
            lineHeight: {
                base: '28px',
                md: '140%'
            }
        },
        addToWishListInTitle: {
            width: {base: '', md: '12px', lg: ''},
            height: {base: '16px', md: '', lg: ''}
        },
        productDetailsDescriptionDesktop: {
            mt: '174px',
            display: 'flex',
            justifyContent: 'space-between',
            textDecoration: 'underline',
            fontSize: 'md',
            fontWeight: 'medium'
        },
        productViewPageSeoLinksTitle: {
            fontWeight: '500',
            fontSize: '12px'
        },
        productViewPageSeoLinks: {
            width: {base: 'auto', md: '695px'},
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            listStyleType: 'none'
        },
        productViewPageSeoLinksLists: {
            margin: {base: '5px', md: 'initial', lg: 'initial'},
            minWidth: {base: '150px', md: 'initial', lg: 'initial'}
        },
        colorSwatches: {
            height: '100%',
            width: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            border: '1px solid',
            borderColor: 'fullBlack'
        }
    }
}
